/** @format */

import React from "react";
import GenerateImagePng from "assets/images/tyons/GeneratePng.png";
import Image from "components/Image";
import GradientButton from "components/GradientButton";
import GenerateIcon from "assets/icons/tryons/GenerateIcon";

interface GenerateImageFrameProps {
   enableButton: boolean;
   generateImage: () => void;
}

const GenerateImageFrame = ({ enableButton, generateImage }: GenerateImageFrameProps) => {
   return (
      <div className="w-full flex flex-col justify-center items-center gap-[1.5rem]">
         <div className="w-[50%]">
            <Image
               imageSrc={GenerateImagePng}
               altText="Frame"
            />
         </div>
         <p className="text-white">Choose the prompts to generate your image</p>
         <GradientButton
            disabled={enableButton}
            onclick={generateImage}
            classname={"!static w-[40%]"}
            buttonText={"Generate Image "}
            icon={<GenerateIcon />}
         />
      </div>
   );
};

export default GenerateImageFrame;
